export const tooltip = {
	"tips": "Dicas",
	"edit": "Editar",
	"deleteSection": "Deletar Seção",
	"deleteItem": "Deletar Item",
	"add": "Adicionar Item",
  "score": "Pontuação do Currículo"
}